import { useEffect, useRef } from "react";
import isEqual from "lodash/isEqual";
import { v4 as uuid } from "uuid";
import { Field, FieldArray } from "formik";
import { EMPTY_STRING } from "../../../constants";
import { redTrashIcon } from "../../../assets/icons";
import { ManageExpression } from "../ServiceFields";

const ONE = 1;
const COUNT = "Count";

const ComputationField = ({
  name,
  values,
  fields,
  label,
  handleChange,
  collections,
  nodes,
  edges,
}) => {
  const initialValues = fields.reduce(
    (obj, field) => ({
      ...obj,
      [field.name]: EMPTY_STRING,
    }),
    {}
  );

  const preSelectedValues = useRef(values[name]);

  useEffect(() => {
    if (values[name] && !isEqual(preSelectedValues.current, values[name])) {
      preSelectedValues.current = values[name];
      handleChange(values[name], name);
    }
  }, [values, name, handleChange]);

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <div className="form-group">
          {values[name].map((data, index) => (
            <div className="my-2" key={data.id}>
              <div className="flex w-full justify-between pr-5">
                <label className="text-sm font-medium w-full truncate ...">
                  {data.name || `${label} ${index + ONE}`}
                </label>
                <button
                  className="hover:opacity-80 active:opacity-100"
                  type="button"
                  onClick={() => arrayHelpers.remove(index)}
                >
                  <img src={redTrashIcon} alt="delete" className="w-6" />
                </button>
              </div>
              <Field
                type="text"
                className="form-control"
                placeholder="Name"
                name={`${name}[${index}].name`}
                value={data.name}
              />
              <div className="flex my-1 gap-2">
                {fields.map((field) => (
                  <Field
                    key={field.name}
                    as="select"
                    className="capitalize form-control"
                    name={`${name}[${index}].${field.name}`}
                    value={data[field.name]}
                  >
                    <option value={EMPTY_STRING} hidden>
                      {field.name}
                    </option>
                    {field.options.map((option) => {
                      return (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      );
                    })}
                  </Field>
                ))}
              </div>
              {data.type && data.type !== COUNT && (
                <ManageExpression
                  name="expression"
                  values={values}
                  expressionKey={`${name}[${[index]}].expression`}
                  handleChange={(e) =>
                    handleChange(e, `${name}[${[index]}].expression`)
                  }
                  collections={collections}
                  nodes={nodes}
                  edges={edges}
                />
              )}
            </div>
          ))}
          <button
            type="button"
            className="rounded items-center w-full p-2 btn-primary-light text-sm font-medium my-1 form-control"
            onClick={() =>
              arrayHelpers.push({
                id: uuid(),
                name: EMPTY_STRING,
                expression: EMPTY_STRING,
                ...initialValues,
              })
            }
          >
            {`Add ${label}`}
          </button>
        </div>
      )}
    />
  );
};

export default ComputationField;
